import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectIsReliable = (state: IApplicationState): boolean => {
  const { isReliable } = selectNewbuilding(state);

  return isReliable;
};
